export const SEARCH_KEYWORD = "SEARCH_KEYWORD";
export const SEARCH_CLOSE_KEYWORD = "SEARCH_CLOSE_KEYWORD";
export const SEARCH_CLOSE_KEYWORD_ERR = "SEARCH_CLOSE_KEYWORD_ERR";
export const SEARCH_RESULT = "SEARCH_RESULT";
export const SEARCH_RESULT_ERR = "SEARCH_RESULT_ERR";